<template>
    <Fragment>
        <div class="radio-group" @click="onChangePaymentRadio">
            <div class="radio-heading">
                <span class="radio-conteiner">
                    <input
                        type="radio"
                        name="payment_radio"
                        :value="payment_data"
                        v-model="payment_selected"
                        @change="onChangePaymentRadio($event)"
                    >
                </span>
                <span class="forma-conteiner">
                    <i class="fas fa-credit-card"></i>
                    {{ cardLabel }}
                </span>
            </div>
        </div>
        <div class="content-payment">
                <div
                    v-if="
                        payment_selected &&
                        (payment_data.list_key || payment_data.id) ==
                            (payment_selected.list_key || payment_selected.id)
                    "
                >
                    <div v-if="showSafraCardTypeSelector" class="form-group required-field">
                        <label>Modalidade do cartão</label>
                        <div class="d-flex">
                            <label class="mr-4 mb-0">
                                <input
                                    type="radio"
                                    name="safrapay_card_payment_type"
                                    value="credit"
                                    :checked="card_payment_type === 'credit'"
                                    @change="onChangeCardPaymentType('credit')"
                                />
                                Crédito
                            </label>
                            <label class="mb-0">
                                <input
                                    type="radio"
                                    name="safrapay_card_payment_type"
                                    value="debit"
                                    :checked="card_payment_type === 'debit'"
                                    @change="onChangeCardPaymentType('debit')"
                                />
                                Débito
                            </label>
                        </div>
                    </div>

                    <!--NUMBER CARD-->
                    <div class="form-group required-field">
                        <label for="numberCardIpag">Número do {{ cardLabel }}</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="numberCardIpag"
                            name="numberCardIpag"
                            :value="number"
                            @input="$emit('update:number', $event.target.value)"
                        />
                        <div v-if="cardValidation.number.$error && !cardValidation.number.required" class="required">* Obrigatório</div>
                        <div v-if="!cardValid" class="required">Não aceitamos esta bandeira de cartão</div>
                    </div>
                    <!--END NUMBER CARD-->
                    <!--HOLDER CARD-->
                    <div class="form-group required-field">
                        <label for="holderCardIpag">Titular do cartão</label>
                        <input
                            type="text"
                            class="form-payment"
                            id="holderCardIpag"
                            name="holderCardIpag"
                            v-uppercase
                            :value="holder"
                            @input="$emit('update:holder', $event.target.value)"
                        />
                        <div v-if="cardValidation.holder.$error && !cardValidation.holder.required" class="required">* Obrigatório</div>
                    </div>
                    <!--END HOLDER CARD-->

                    <!--BRAND CARD-->
                    <!-- <div class="form-group required-field">
                        <label for="brandCardIpag">Bandeira do cartão</label>
                        <select
                            class="form-payment"
                            @input="$emit('update:method', $event.target.value)"
                        >
                            <option value="" selected>Selecione a bandeira</option>
                            <option v-for="item in payment_data.payment_method" :key="item.id" :value="item.method">{{item.method}}</option>
                        </select>
                        <div v-if="validate.formIpagCard.method.$error && !validate.formIpagCard.method.required" class="required">* Obrigatório</div>
                    </div> -->
                    <!--END BRAND CARD-->

                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group required-field mb-0">
                                <label>Vencimento do cartão</label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group required-field mb-0">
                                <label>Cvv</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-1">
                        <!--EXPIRY MONTH-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_month', $event.target.value)"
                            >
                                <option value="" selected>Mês</option>
                                <option v-for="count in 12" :key="count" :value="count < 10 ? '0'+count : count">{{ count < 10 ? '0'+count : count }}</option>
                            </select>
                            <div v-if="cardValidation.expiry_month.$error && !cardValidation.expiry_month.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY MONTH-->

                        <!--EXPIRY YEAR-->
                        <div class="col-md-4">
                            <select
                                class="form-payment"
                                @input="$emit('update:expiry_year', $event.target.value)"
                            >
                                <option value="" selected>Ano</option>
                                <option v-for="(n, $index) in 12" :key="n" :value="$index + countDate">{{$index + countDate}}</option>
                            </select>
                            <div v-if="cardValidation.expiry_year.$error && !cardValidation.expiry_year.required" class="required">* Obrigatório</div>
                        </div>
                        <!--END EXPIRY YEAR-->

                        <!--CVV CARD-->
                        <div class="col-md-4">
                            <input
                                type="text"
                                class="form-payment"
                                id="cvvIpag"
                                name="cvvIpag"
                                :max-length="maxlengthCvv"
                                placeholder="cvv"
                                @input="$emit('update:cvv', $event.target.value)"
                            />
                            <div
                                v-if="cardValidation.cvv.$error && !cardValidation.cvv.required"
                                class="required"
                            >
                                * Obrigatório
                            </div>
                        </div>
                        <!--END CVV CARD-->
                    </div>

                    <!--INSTALLMENTS-->
                    <div v-if="!isDebitPayment" class="form-group required-field">
                        <label for="installments_ipag">Parcelas</label>
                         <select class="form-payment" @input="$emit('update:installment', $event.target.value)">
                            <template v-for="i in max_installments">
                                <option v-if="(i == 1) || ((totalAmount / i) >= +min_price_installment )"
                                :key="i" :value="i" :selected="i == 1">
                                {{ showInstallment(i) }}
                            </option>

                            </template>

                        </select>
                        <div v-if="cardValidation.installment.$error && !cardValidation.installment.required" class="required">* Selecione uma parcela</div>
                    </div>
                    <!--END INSTALLMENTS-->
                </div>
        </div>
    </Fragment>
</template>

<script>
import {Fragment}  from 'vue-fragment'
import {mapState, mapActions} from 'vuex'
import Currency from '../../helpers/parseCurrency'

export default {
    name: 'Rede',
     directives: {
        "uppercase": {
            update: function (el) {
                el.value = el.value.toUpperCase()
            }
        }
    },
    props: {
        //numero de parcelas sem juros definido pela empresa no painel administrativo
        interest_free_installments: {
            default: 0
        },
        payment_data: {
            required: true,
            default: Object,
            type: Object
        },
        payment_selected: {
            default: Object,
            type: Object
        },
        holder: {
            default: ''
        },
        method: {
            default: '',
        },
        number: {
            default: ''
        },
        expiry_month: {
            default: ''
        },
        expiry_year: {
            default: ''
        },
        cvv: {
            default: ''
        },
        installment: {
            default: ''
        },
        card_payment_type: {
            default: 'credit',
            type: String
        },
        safra_credit_enabled: {
            default: true,
            type: Boolean
        },
        safra_debit_enabled: {
            default: false,
            type: Boolean
        },
        validate: {
            required: true
        },
        min_price_installment:{
            default:0
        },
        max_installments:{
            default:10
        }
    },
    components: {
        Fragment
    },
    data() {
        return {
            maxlengthCvv: 3,
            installments: 10,
            disabledInstallments: true,
            countDate: 0,
            currency: Currency,
            cardValid: true,
            availableInsatallments: 0
        }
    },
    created() {
        this.countDate = new Date().getFullYear()
    },
    methods: {
        ...mapActions("cart", [
            "ActionSetItemsCart"
        ]),
        onChangeInstallment(event)
        {
            let selected = event.target.value.split(';')
            let itemsCart = this.itemsCart
            itemsCart.totalAmount = selected[2]

        },
        onChangePaymentRadio()
        {
            this.$emit('onChangePayment', this.payment_data)
        },
        onChangeCardPaymentType(type)
        {
            this.$emit('update:card_payment_type', type)
            if (type === 'debit') {
                this.$emit('update:installment', 1)
            }
        },
        showInstallment(index)
        {
            if (this.isSafraIssuerInstallment(index)) {
                return `${index}x com juros do emissor`;
            }

            const prefix = index == 1 ? 'à vista - ' : index+'x de ';
            const suffix = this.getInstallmentDescription(index);

            return `${prefix}${this.currency.money(this.getInstallmentAmount(index))}${suffix ? ' ' + suffix : ''}`;
        },
        getInstallmentDescription(index)
        {
            if (index == 1) {
                return '';
            }

            return this.hasInstallmentInterest(index) ? 'com juros' : 'sem juros';
        },
        hasInstallmentInterest(index)
        {
            return Number(index) > Number(this.interest_free_installments ?? 0);
        },
        isSafraPayment()
        {
            const name = String(this.payment_data?.name || this.payment_selected?.name || '').toUpperCase();
            return name === 'SAFRA PAY';
        },
        isSafraIssuerInstallment(index)
        {
            return this.isSafraPayment() && this.hasInstallmentInterest(index);
        },
        getInstallmentAmount(index)
        {
            return this.getTotalAmountWithInstallmentFee(index) / index;
        },
        getTotalAmountWithInstallmentFee(index)
        {
            if (this.isSafraPayment()) {
                return this.totalAmount;
            }

            if (this.hasInstallmentInterest(index) && Number(this.payment_selected.installment_fee ?? 0) > 0) {
                const fee = Number(this.payment_selected.installment_fee) / 100;
                const totalAmount = (this.totalAmount * ((Math.pow((1 + fee), index) * fee) / (Math.pow((1 + fee), index) - 1))) * index;

                return totalAmount.toFixed(2);
            }

            return this.totalAmount;
        }
    },
    computed: {
        ...mapState("cart", [
            "itemsCart"
        ]),
        totalAmount() {

            return this.itemsCart.totalAmount.toFixed(2)

        },
        isDebitPayment() {
            if (!this.isSafraPayment()) {
                return this.payment_data?.type === 'debit'
            }

            if (!this.safra_credit_enabled && this.safra_debit_enabled) {
                return true
            }

            if (this.safra_credit_enabled && !this.safra_debit_enabled) {
                return false
            }

            return this.card_payment_type === 'debit'
        },
        showSafraCardTypeSelector() {
            return this.isSafraPayment()
                && this.safra_credit_enabled
                && this.safra_debit_enabled
        },
        cardLabel() {
            return this.isDebitPayment ? 'Cartão de débito' : 'Cartão de crédito'
        },
        cardValidation() {
            return this.isSafraPayment()
                ? this.validate.formSafraCard
                : this.validate.formIpagCard
        }
    }
}
</script>
